import { withRouter, Redirect } from "react-router-dom"
import { Typography, Box, Snackbar, CircularProgress, } from "@material-ui/core";
import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import CryptoJS from 'crypto-js'

import useStyles from './multifactorauthentication.style';
import logo from "../../../images/logo_full.png";
import { MobileButton, MobileOutlinedButton, MobileRegularPage, MobileAlert } from '../../../components';

const cookies = new Cookies();

const SaveLocalRedirect = () => {
    const [redirectPath, setRedirectPath] = useState('');

    useEffect(() => {
        const syncLocalStorageData = async () => {
            let localHavePlanData = localStorage.getItem('havePlan');
            if (!localHavePlanData) return;

            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT}/saveplan`, {
                    method: 'post',
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    },
                    body: new URLSearchParams({
                        havePlan: localHavePlanData
                    })
                });
                let json = await response.json();
                if (!response.ok) console.log(json.message);
            } catch (error) {
                console.log(error);
            } finally {
                localStorage.removeItem('havePlan');
            };
        };

        syncLocalStorageData();
    });

    useEffect(() => {
        const getHealthProfile = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (!response) return;
                let json = await response.json();
                setRedirectPath('/app/dashboard');
            } catch (error) {
                console.log(error);
            };
        };

        getHealthProfile();
    }, []);

    if (!redirectPath) return null;

    return (
        <Redirect to={redirectPath} />
    );
};


const MultiFactorAuthentication = () => {

    const classes = useStyles();
    const [email, setEmail] = useState('');
    const [authenticated, setAuthenticated] = useState(false);
    const [isMFA, setIsMFA] = useState(false);
    const [apiValidationResult, setApiValidationResult] = useState('');
    const [sending, setSending] = useState(false);
    const [isProvider, setIsProvider] = useState(false);
    const [providerAuthenticated, setProviderAuthenticated] = useState(false);
    const [isPatientSignIn, setIsPatientSignIn] = useState('');

    useEffect(() => {
        const encryptEmail = CryptoJS.AES.decrypt(localStorage.getItem('email'), process.env.REACT_APP_SECRET_KEY);
        setEmail(encryptEmail.toString(CryptoJS.enc.Utf8));
        setIsProvider(localStorage.getItem('isProvider'));
        setIsPatientSignIn(localStorage.getItem('isPatientSignIn'));
    })

    const handleSkip = async (e) => {
        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH_ACCESSTOKEN}`, {
                method: 'post',
                body: new URLSearchParams({
                    email: email
                })
            })
            if (!response.ok) {
                let json = await response.json();
                setApiValidationResult({ severity: 'error', message: json.message || json.errors[0].msg });
                return;
            };
            let json = await response.json();
            cookies.set('token', json.token, { path: '/', expires: new Date(Date.now() + 7200000) });
            if (isProvider === 'true' && isPatientSignIn === 'false') setProviderAuthenticated(true);
            else
                setAuthenticated(true);
        } catch (error) {
            console.log(error.message);
            setApiValidationResult({ severity: 'error', message: error.message });
        } finally {

        };
    };

    const handleMFASubmit = async (e) => {
        setSending(true);
        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH_SETMFA}`, {
                method: 'post',
                body: new URLSearchParams({
                    email: email
                })
            })
            if (!response.ok) {
                let json = await response.json();
                setApiValidationResult({ severity: 'error', message: json.message || json.errors[0].msg });
                return;
            };
            setIsMFA(response.ok);

            localStorage.setItem('is2FAEnabled', response.ok)

        } catch (error) {
            console.log(error.message);
            setApiValidationResult({ severity: 'error', message: error.message });
        }
        finally {
            setSending(false);
        }
    }

    const handleSignIn = async () => {
        localStorage.clear();
        cookies.remove('token', { path: '/' });
        if (isProvider && isPatientSignIn === 'false') window.location.replace('/provider');
        else window.location.replace('/app');
    }

    const handleMessageClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setApiValidationResult({ severity: 'error', message: '' });
    };


    if (authenticated) return <SaveLocalRedirect />;

    if (providerAuthenticated) return <Redirect to='/provider' />

    if (isMFA) return <Redirect to='/app/otpverification' />

    return (
        <>
            <MobileRegularPage>
                <Box className={classes.title}>
                    <Box>
                        <img src={logo} alt="logo" />
                        <Typography variant="h4">Simplify 2-Step Verification</Typography>
                        <Typography>{email}</Typography>
                    </Box>
                </Box>

                <Box className={classes.buttonContainer}>

                    <MobileButton label='set up'
                        className={classes.button}
                        onClick={handleMFASubmit}>
                        {sending && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </MobileButton>

                    <MobileOutlinedButton
                        className={classes.cancelbtn}
                        onClick={handleSkip} label='Skip'
                    />
                </Box>

                <Box style={{ width: "69%", padding: "2em" }}>
                    <MobileButton label='Sign In'
                        className={classes.button}
                        onClick={handleSignIn} />
                </Box>

                {apiValidationResult &&
                    <Snackbar open={apiValidationResult.message !== ''} autoHideDuration={6000} onClose={handleMessageClose}>
                        <MobileAlert onClose={handleMessageClose} severity={apiValidationResult.severity}>
                            {apiValidationResult.message}
                        </MobileAlert>
                    </Snackbar>
                }

            </MobileRegularPage>

        </>
    )
}

export default withRouter(MultiFactorAuthentication);